import React from 'react';
import { Box, Container, Grid, Typography, Link, IconButton } from '@mui/material';
import { Facebook, Instagram, WhatsApp, Email, Phone } from '@mui/icons-material';
import { useDesign } from '../context/DesignContext';

const Footer = () => {
  const { config } = useDesign();
  const { footer } = config;

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: (theme) => (theme.palette as any).custom?.footerBg || theme.palette.grey[900],
        color: 'common.white',
        py: 6,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold' }}>
              Blüm
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
              {footer?.description || 'Los mejores arreglos florales con entrega a domicilio en México. Flores frescas y diseños exclusivos para cada ocasión especial.'}
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <IconButton 
                component="a" 
                href={footer?.socialLinks?.facebook || '#'} 
                target="_blank" 
                rel="noopener noreferrer"
                sx={{ color: (theme) => (theme.palette as any).custom?.logoColor || theme.palette.primary.main, '&:hover': { color: 'primary.dark' } }}
              >
                <Facebook />
              </IconButton>
              <IconButton 
                component="a" 
                href={footer?.socialLinks?.instagram || '#'} 
                target="_blank" 
                rel="noopener noreferrer"
                sx={{ color: (theme) => (theme.palette as any).custom?.logoColor || theme.palette.primary.main, '&:hover': { color: 'primary.dark' } }}
              >
                <Instagram />
              </IconButton>
              <IconButton 
                component="a" 
                href={footer?.socialLinks?.whatsapp || '#'} 
                target="_blank" 
                rel="noopener noreferrer"
                sx={{ color: (theme) => (theme.palette as any).custom?.logoColor || theme.palette.primary.main, '&:hover': { color: 'primary.dark' } }}
              >
                <WhatsApp />
              </IconButton>

        </Box>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold' }}>
              Servicios
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link href="#" sx={{ color: 'text.secondary', textDecoration: 'none', '&:hover': { color: 'primary.main' } }}>
                Envío Express
              </Link>
              <Link href="#" sx={{ color: 'text.secondary', textDecoration: 'none', '&:hover': { color: 'primary.main' } }}>
                Arreglos Personalizados
              </Link>
              <Link href="#" sx={{ color: 'text.secondary', textDecoration: 'none', '&:hover': { color: 'primary.main' } }}>
                Eventos Especiales
              </Link>
              <Link href="#" sx={{ color: 'text.secondary', textDecoration: 'none', '&:hover': { color: 'primary.main' } }}>
                Suscripciones Mensuales
              </Link>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold' }}>
              Contacto
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Phone sx={{ color: (theme) => (theme.palette as any).custom?.logoColor || theme.palette.primary.main }} />
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  {footer?.contact?.phone || '+52 2222222222'}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Email sx={{ color: (theme) => (theme.palette as any).custom?.logoColor || theme.palette.primary.main }} />
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  {footer?.contact?.email || 'soporte@blum-art.mx'}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  {footer?.contact?.hours || 'Horario: Lunes a Domingo 9:00 - 20:00 hrs'}
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
        
        <Box sx={{ mt: 4, pt: 4, borderTop: '1px solid', borderColor: 'grey.700', textAlign: 'center' }}>
          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
            © 2024 Blüm. Todos los derechos reservados.
          </Typography>
          <Link href="/privacy-policy" sx={{ color: 'text.secondary', fontSize: '0.875rem', textDecoration: 'none', '&:hover': { color: 'primary.main', textDecoration: 'underline' } }}>
            Política de Privacidad
          </Link>
          <Typography component="span" sx={{ mx: 1, color: 'text.secondary' }}>|</Typography>
          <Link href="/support" sx={{ color: 'text.secondary', fontSize: '0.875rem', textDecoration: 'none', '&:hover': { color: 'primary.main', textDecoration: 'underline' } }}>
            Soporte
          </Link>
          <Typography component="span" sx={{ mx: 1, color: 'text.secondary' }}>|</Typography>
          <Link href="/marketing" sx={{ color: 'text.secondary', fontSize: '0.875rem', textDecoration: 'none', '&:hover': { color: 'primary.main', textDecoration: 'underline' } }}>
            App
          </Link>
          <Typography component="span" sx={{ mx: 1, color: 'text.secondary' }}>|</Typography>
          <Link href="/copyright" sx={{ color: 'text.secondary', fontSize: '0.875rem', textDecoration: 'none', '&:hover': { color: 'primary.main', textDecoration: 'underline' } }}>
            Copyright
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;